import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../../components/Button";
import TableComponent from "../../../components/TableComponent";
import Confirm from "../../../components/Confirm";
import { getTrainings, deleteTrainingCourseById } from "../../../api/training.deprecated";

import { convertDateTime } from "../../../services/formatters";

const CourseTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const [trainings, setTrainings] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id, courseId) {
    setSelectedId(id);
    setSelectedCourseId(courseId);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteTrainingCourseById(selectedId, selectedCourseId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getTrainings();

      setTrainings(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("course_training.title")}</Typography>
      {trainings ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/trainings/add`)}>
              <PostAddIcon />
              {t("course_training.add_action")}
            </Button>
          }
          search={["displayname", "id"]}
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("course_id"), style: { width: "5%" } },
            { title: t("name"), style: { width: "10%" } },
            { title: t("position.name"), style: { width: "10%" } },
            { title: t("status"), style: { width: "10%" } },
            { title: t("training_pages.e_learning"), style: { width: "5%" } },
            { title: t("classroom"), style: { width: "5%" } },
            { title: t("training_pages.practical"), style: { width: "5%" } },
            { title: t("start_date"), style: { width: "10%" } },
            { title: t("end_date"), style: { width: "10%" } },
            { title: t("training.slots"), style: { width: "5%" } },
            //{ title: "Inscribe", style: { width: "5%" } },
            { title: t("actions"), style: { width: "10%" } },
          ]}
          items={trainings}
          renderChildren={(training) => (
            <TableRow key={training.id}>
              <TableCell>{training.id}</TableCell>
              <TableCell>{training.courseId}</TableCell>
              <TableCell>{training.displayname}</TableCell>
              <TableCell>{training.positions}</TableCell>
              <TableCell>{training.status}</TableCell>
              <TableCell>{training.isELearning === 1 ? t("yes") : t("no")}</TableCell>
              <TableCell>{training.isClassroom === 1 ? t("yes") : t("no")}</TableCell>
              <TableCell>{training.isPractical === 1 ? t("yes") : t("no")}</TableCell>
              <TableCell>{convertDateTime(training.trainingStartDate)}</TableCell>
              <TableCell>{convertDateTime(training.trainingEndDate)}</TableCell>
              <TableCell>{training.trainingSlot}</TableCell>
              {/*   <TableCell>{training.userInscribe}</TableCell> */}

              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/trainings/edit/${training.id}`)}
                  title={t("course_training.edit_action")}
                />
                <Button
                  icon={<AddCircleIcon />}
                  onClick={() => history.push(`/trainings/inscribe/${training.id}`)}
                  title={t("course_training.inscribe_users")}
                />
                {/*                 
                <Button
                  icon={<MoreTimeIcon />}
                  onClick={() => history.push(`/trainings/schedule/trainer/${training.id}`)}
                  title="Schedule training"
                />
                */}
                {training.isPractical == 1 && (
                  <Button
                    icon={<DateRangeIcon />}
                    onClick={() => history.push(`/trainings/schedule/practical/${training.id}`)}
                    title={t("course_training.schedule_practical")}
                  />
                )}

                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(training.id, training.courseId)}
                  title={t("course_training.delete_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedId ? (
        <Confirm title={t("course_training.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("course_training.delete_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default CourseTraining;
